(function () {
  var TEXT = /^(write a review|be the first.*|\|)$/i;
  var SHADOW_CSS = '[class*="new-review"],[class*="write"],[class*="bottom-line-text"],[class*="separator"],[class*="divider"],.text-m{display:none!important}' +
                   'svg{width:14px!important;height:14px!important;max-width:14px!important}' +
                   '[class*="star"]:not(svg):not(img){font-size:14px!important;letter-spacing:2px!important;line-height:1!important}';

  function moveReviews() {
    document.querySelectorAll('.product-single__metas').forEach(function (metas) {
      var row = metas.querySelector('.title_price_main');
      var review = metas.querySelector('.product-single__reviews');
      if (row && review && row.nextElementSibling !== review) row.insertAdjacentElement('afterend', review);
    });
  }

  // visit every element, also inside open shadow roots
  function each(root, fn) {
    var kids = root.children || [];
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      fn(el);
      if (el.shadowRoot) {
        if (!el.shadowRoot.querySelector('style[data-piranga]')) {
          var st = document.createElement('style'); st.setAttribute('data-piranga', ''); st.textContent = SHADOW_CSS;
          el.shadowRoot.appendChild(st);
        }
        each(el.shadowRoot, fn);
      }
      each(el, fn);
    }
  }

  function starsOnly(col) {
    each(col, function (el) {
      if (el.children.length || el.shadowRoot) return;                       // leaf nodes only
      if (el.closest && el.closest('form, .product-info-sidebar, .cstm_pro_desc')) return;   // never touch the buy box / info list
      var t = (el.textContent || '').trim();
      if (!t || !TEXT.test(t)) return;
      var hide = el;
      while (hide.parentElement && hide.parentElement !== col &&
             (hide.parentElement.textContent || '').trim() === t) hide = hide.parentElement;
      hide.style.setProperty('display', 'none', 'important');
    });
  }

  // Show the review row only when the product has >= 1 review.
  function reviewCount(root) {
    var texts = [];
    (function grab(n) {
      texts.push(n.textContent || '');
      if (n.shadowRoot) Array.prototype.forEach.call(n.shadowRoot.children, grab);
    })(root);
    Array.prototype.forEach.call(root.querySelectorAll('*'), function (el) { if (el.shadowRoot) texts.push(el.shadowRoot.textContent || ''); });
    var m = texts.join(' ').replace(/\u00a0/g, ' ').match(/(\d[\d,\.]*)\s*(?:k\s*)?reviews?/i);
    return m ? parseFloat(m[1].replace(/,/g, '')) : 0;
  }
  function reviewRow() {
    document.querySelectorAll('.bwp-single-info .product-single__reviews').forEach(function (root) {
      root.classList.toggle('piranga-has-reviews', reviewCount(root) > 0);
    });
  }

  function run() {
    moveReviews();
    document.querySelectorAll('.bwp-single-info .product-single__reviews, .bwp-single-info [class*="yotpo"]').forEach(function (r) { if (!r.closest('.product-single__reviews') || r.classList.contains('product-single__reviews')) starsOnly(r); });
    reviewRow();
  }

  function start() {
    run();
    var col = document.querySelector('.bwp-single-info');
    if (!col) return;
    var n = 0, timer = null;
    var mo = new MutationObserver(function () {
      clearTimeout(timer); timer = setTimeout(function () { run(); if (++n > 25) mo.disconnect(); }, 80);
    });
    mo.observe(col, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', function () { setTimeout(run, 500); setTimeout(run, 1500); setTimeout(run, 3500); });
  document.addEventListener('shopify:section:load', start);
})();

/* Fit guard: on desktop the info column must end above the bottom edge of the FIRST product image.
   If it is taller, tighten spacing in two steps (piranga-fit-1, then piranga-fit-2). */
(function () {
  function fit() {
    if (window.innerWidth < 992) { document.querySelectorAll('.bwp-single-info').forEach(function (c) { c.classList.remove('piranga-fit-1', 'piranga-fit-2'); }); return; }
    document.querySelectorAll('.bwp-single-info').forEach(function (col) {
      var wrap = col.closest('.row') || document;
      var img = wrap.querySelector('.bwp-single-image img');
      var metas = col.querySelector('.product-single__metas');
      if (!img || !metas) return;
      var limit = img.getBoundingClientRect().height;           // height of the first image = the "red line"
      if (!limit || limit < 200) return;                          // image not loaded yet
      col.classList.remove('piranga-fit-1', 'piranga-fit-2');
      if (metas.offsetHeight <= limit - 24) return;
      col.classList.add('piranga-fit-1');
      if (metas.offsetHeight <= limit - 24) return;
      col.classList.add('piranga-fit-2');
    });
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(fit, 120); }
  window.addEventListener('load', function () { fit(); setTimeout(fit, 800); setTimeout(fit, 2500); });
  window.addEventListener('resize', soon);
  document.addEventListener('change', soon);
  document.addEventListener('shopify:section:load', soon);
  if (document.readyState !== 'loading') soon(); else document.addEventListener('DOMContentLoaded', soon);
})();

/* Mark the Product Details intro when it is longer than its 3-line window, so CSS can fade the last line. */
(function () {
  function mark() {
    document.querySelectorAll('.piranga-details-preview__intro').forEach(function (p) {
      p.classList.toggle('is-clamped', p.scrollHeight > p.clientHeight + 2);
    });
  }
  window.addEventListener('load', function () { mark(); setTimeout(mark, 600); });
  window.addEventListener('resize', mark);
  document.addEventListener('shopify:section:load', mark);
  if (document.readyState !== 'loading') mark(); else document.addEventListener('DOMContentLoaded', mark);
})();

/* Feature text: pasted copy can contain non-breaking spaces, which stops lines wrapping to 2 lines. */
(function () {
  function normalise() {
    document.querySelectorAll('.product-feature-video').forEach(function (root) {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) { if (n.nodeValue.indexOf('\u00a0') > -1) n.nodeValue = n.nodeValue.replace(/\u00a0/g, ' '); }
    });
  }
  if (document.readyState !== 'loading') normalise(); else document.addEventListener('DOMContentLoaded', normalise);
  window.addEventListener('load', normalise);
})();

/* No white gap between the first screen (gallery + info) and the next section:
   measure the real distance from the lowest visible content to the next section and pull the section up by it. */
(function () {
  function close() {
    var sec = document.querySelector('.shopify-section.main_pro_class') || document.querySelector('.main_pro_class');
    if (!sec) return;
    var next = sec.nextElementSibling;
    while (next && next.offsetHeight === 0) next = next.nextElementSibling;
    if (!next) return;
    var y = window.pageYOffset || 0, bottoms = [];
    var desktop = window.innerWidth >= 992, prev = next.style.marginTop;
    // On phones the (sticky) info block sits below the gallery and can only be measured near the top of the page;
    // if we are scrolled down, keep the last good value instead of resetting it.
    if (!desktop && y >= 60) return;
    next.style.marginTop = '';                                   // re-measure from the natural layout
    sec.querySelectorAll('.bwp-single-image img').forEach(function (im) {
      var r = im.getBoundingClientRect();
      if (r.height > 80 && r.width > 80 && getComputedStyle(im).visibility !== 'hidden') bottoms.push(r.bottom + y);
    });
    if (y < 60) {                                                // info column is sticky: only trust it near the top of the page
      var last = sec.querySelector('.piranga-details-preview') || sec.querySelector('.product-single__metas');
      if (last) bottoms.push(last.getBoundingClientRect().bottom + y);
    }
    if (!bottoms.length) { next.style.marginTop = prev; return; }
    var gap = (next.getBoundingClientRect().top + y) - Math.max.apply(null, bottoms);
    if (gap > 2 && gap < 400) next.style.marginTop = (-Math.round(gap)) + 'px';
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(close, 150); }
  window.addEventListener('load', function () { close(); setTimeout(close, 600); setTimeout(close, 1800); });
  window.addEventListener('resize', soon);
  document.addEventListener('change', soon);
  document.addEventListener('shopify:section:load', soon);
  document.querySelectorAll('.bwp-single-image img').forEach(function (im) { if (!im.complete) im.addEventListener('load', soon); });
})();
